import { ClientRef } from '../ClientRef';

export const serviceTypeEnum = {
    TOUR: 'Tour',
    FLIGHT: 'Flight',
    HOTEL: 'Hotel',
    CAR: 'Car',
    INSURANCE: 'Insurance',
    VISA: 'Visa',
    TRANSPORT: 'Transport',
    CRUISE: 'Cruise',
    TRAIN: 'Train',
    GIFT_CARD: 'Gift Card',
    ESCORTED_TOUR: 'Escorted Tour',
    PACKAGE: 'Package',
    ACTIVITIES: 'Activities',
    RESTAURANT: 'Restaurant',
    FERRY: 'Ferry',
    GUIDE: 'Guide',
    GENERAL: 'General'
};

export interface ServiceType extends ClientRef {
    _id: string;
    name: string;
    isDeleted: Date;
}

export default ServiceType;
